/**
 * Navigator router — explicit version dispatch.
 *
 * Version detection: navigator_config_v2.version field in DB JSONB.
 *   - 'v3' → renders InteractivePropertyMapV3 (Skorupki 1 — Argali Development)
 *   - 'v2' (or missing) → returns null, caller falls back to legacy V2 path
 *
 * V2 path (PropertySVGOverlayV2 + InteractivePropertyMap.js) intentionally
 * untouched to preserve existing tenants (Wywrockiego-11, Hegra, etc.).
 */

import React from 'react';
import InteractivePropertyMapV3 from './v3/InteractivePropertyMapV3';
import InteractivePropertyMapV180 from './v180/InteractivePropertyMapV180';

export const NAVIGATOR_VERSIONS = Object.freeze({
  V2: 'v2',
  V3: 'v3',
});

/**
 * Reads navigator version from investment data.
 * @param {Object} investmentData
 * @returns {'v2' | 'v3'}
 */
export function getNavigatorVersion(investmentData) {
  const v = investmentData?.navigatorConfigV2?.version;
  return v === NAVIGATOR_VERSIONS.V3 ? NAVIGATOR_VERSIONS.V3 : NAVIGATOR_VERSIONS.V2;
}

/**
 * Returns true when V3 should handle rendering (caller skips legacy path).
 */
export function isNavigatorV3(investmentData) {
  return getNavigatorVersion(investmentData) === NAVIGATOR_VERSIONS.V3;
}

/**
 * Tryb dwóch ujęć (obrót o 180°) zamiast panoramy 360°.
 * Osobna gałąź renderowania — ścieżka 360° nie jest modyfikowana.
 */
export function isNavigator180(investmentData) {
  return investmentData?.navigatorConfigV2?.is180 === true;
}

/**
 * Render V3 navigator (full self-contained: image + overlay + toolbar + zoom).
 * Caller must check isNavigatorV3() first; this component does not fall back.
 *
 * `is180` → osobny komponent dwóch ujęć; wszystko inne → dotychczasowy tryb 360°.
 */
export function NavigatorV3(props) {
  if (isNavigator180(props.investmentData)) {
    return <InteractivePropertyMapV180 {...props} />;
  }
  return <InteractivePropertyMapV3 {...props} />;
}
